import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';
import Datetime from "react-datetime";
import CsvDownloader from 'react-csv-downloader';

// ui icons
import Close from "@material-ui/icons/Close";
import Assignment from "@material-ui/icons/Assignment";
import Search from "@material-ui/icons/Search";
import Description from "@material-ui/icons/Description";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CircularProgress from '@material-ui/core/CircularProgress';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import EventNoteIcon from '@material-ui/icons/EventNote';

// ui components
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Tooltip from "@material-ui/core/Tooltip";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

// core components 
import Card from "beaktShared/components/Card/Card.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Select from "react-select";
import { ValidSelect } from "beaktShared/helpers/validselect";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import ContratoVenda from "beaktClinic/views/Venda/ContratoVenda";
import ContratoVendaCamaCam from "beaktClinic/views/Venda/ContratoVendaCamaCam";
import CancelamentoBeakt from "beaktClinic/views/Venda/Cancelamentos/CancelamentoBeakt";
import AgendamentoContrato from "beaktDay/views/AdminAgenda/Agenda/AgendamentoContrato";
import SweetAlert from "react-bootstrap-sweetalert";
import ContratoVendaDM2 from 'beaktClinic/views/Venda/ContratoVendaDM2';

// services
import { MaskDate, formateDate, formateDateandTime, validateDate, convertDate, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi, UsePutApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
import { useGetApi } from 'beaktShared/services/crudeApiService';

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function GestaoVendas({clienteId, estabelecimentoId, BtnFinalizaVenda}) { 
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const { register, setValue, errors, setError, clearError, getValues } = useForm({mode: "onBlur"});
    
    const [vendaContrato, setvendaContrato] = React.useState(null);
    
    const [showCancelarPagamento, setshowCancelarPagamento] = React.useState(false);    
    const [cancelamentoBeakt, setcancelamentoBeakt] = React.useState(false);
    const [pesquisaContrato, setpesquisaContrato] = React.useState(false);

    const [notification, setNotification] = React.useState({
    show:false,
    color:'info',
    message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-7, 'days')));
    const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));
    
    useEffect(() => {                 
        verifyAcess();
    }, []);

    const verifyAcess = () =>{  
        var estabelecimento_temp = 0;
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            if(estabelecimentoId) // Recebendo o Id do estabelecimento do componente pai
            {
                setestabelecimento(estabelecimentoId);
                setshowSelectEstabelecimentos(false)
                estabelecimento_temp = estabelecimentoId;
            }
            else
            {
                setshowSelectEstabelecimentos(true);
                LoadEstabelecimentos();
                setpesquisaContrato(true);
            } 
        }
        else //Acessando tela pelo modulo Clinica   
        {
            setestabelecimento(session.estabelecimentoId);
            setshowSelectEstabelecimentos(false);
            estabelecimento_temp = session.estabelecimentoId;
            setpesquisaContrato(false);
	    handleSetup();
        }
        
        let dataIniConvertida = convertDate(dtini);
        let dataFimConvertida = convertDate(dtfim);
        
        creatObjandCallLoadVendas(estabelecimento_temp,dataIniConvertida,dataFimConvertida);
    }
    const intialValues = {
        vendaContrato:''
    };
    const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(false);
    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [estabelecimento, setestabelecimento] = React.useState(0);
    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
        if (result.status !== 200) {
            showNotification(result.message, 'error')
            setisLoadingEstabelecimento(false);
            return false;
        }

        setisLoadingEstabelecimento(false);
        setestabelecimentos(result.data);
        return true;
        });
    };
    const handleEstabelecimentoChange = event => {
        let value = event
        setestabelecimento(value);
        setValue("estabelecimento", value);
        if (value !== "")
            clearError("estabelecimento");
    };

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() + 
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }

    
    const [showBtnAgendamentoContrato, setshowBtnAgendamentoContrato] = React.useState(false);

    const handleSetup = (showModal) =>{

        var sessionUse = session;

        const endPoint = "agendamentos/getSetupEstabelecimento/"+sessionUse.estabelecimentoId
        UseGetApiSimple(endPoint,0).then(result=>{    

            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                return false; 
            }  

            let lstSetup = [];

            result.data.map(item => lstSetup.push({
                setupEstabelecimentoId: item.setupEstabelecimentoId,
                estabelecimentoId: item.estabelecimentoId,
                setupId: item.setupId,
                ativo: item.ativo,
                descricao: item.setup.descricao,
                codigo: item.setup.codigo
            }));
            
            let AgendamentoContrato = lstSetup.filter(f => f.codigo == 'SETUP01')[0];

            if(AgendamentoContrato.ativo === true){
                setshowBtnAgendamentoContrato(true);
            }

            return true;                
        }); 
    }
        

    const handleClickPesquisa = () =>{        
        
        let data = getValues();

        if(data.vendaContrato != "" && data.vendaContrato != undefined){
            creatObjandCallLoadVendas(0,null,null,data.vendaContrato);
        }
        else{
            if (showSelectEstabelecimentos && (estabelecimento === "" || estabelecimento === 0))
                return setError("estabelecimento", "required")
            else
                clearError("estabelecimento")

            if(data.dtini === "")
            {
                setError("dtini","required", t('label.required'))
                return false;
            }
            else
                clearError("dtini")
            
            if(data.dtfim === "")
            {
                setError("dtfim","required",  t('label.required'))
                return false;
            }
            else
                clearError("dtfim")
            
            if (!validateDate(data.dtini)) {
                setError("dtini", "invaliddate", t('error_message.invalid_date'))
                return false;
            }
            else
                clearError("dtini")
            
            if (!validateDate(data.dtfim)) {
                setError("dtfim", "invaliddate", t('error_message.invalid_date'))
                return false;
            }
            else
                clearError("dtfim")
            
                
            var dataIniConvertida = convertDate(data.dtini);
            var dataFimConvertida = convertDate(data.dtfim);

            if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
            {
                if(monthDiff(dataIniConvertida,dataFimConvertida) > 3){            
                    showNotification(t('information_message.select_a_period_of_a_maximum_of_3_months'), 'danger')
                    return false; 
                }
            } 
            
            creatObjandCallLoadVendas(estabelecimento,dataIniConvertida,dataFimConvertida,data.vendaContrato);
        }
    };

    const creatObjandCallLoadVendas = (estabelecimento,dataIniConvertida,dataFimConvertida,vendaContrato) =>{    
        
        let clienteIdEnviar = 0;
        if(clienteId)
            clienteIdEnviar = clienteId;

        let obj = {
            estabelecimentoId: estabelecimento,
            dataIni: dataIniConvertida,
            dataFim: dataFimConvertida,
            clienteId: clienteIdEnviar,
            vendaId: vendaContrato,
            cpfCliente: "",
            franquiaId: session.franquiaId,
        }
        loadVendas(obj);
    }

    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const loadVendas = (obj) =>{
        setisLoadingList(true);       
        const endPoint = "vendas/byestabelecimentoeperiodo/";
        UsePostApi(endPoint,obj).then(result=>{    
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false; 
            }    
            setlist(result.data);
            setisLoadingList(false);   
            setloadingTable(false); 
            loadDataCsv(result.data);

            return true;                
        });  
    }
    
    // *******************************************************************************
    // ********************************** CABEÇALHO CSV **********************************
    // *******************************************************************************

    const columnsCSV = [
        { displayName: "Estabelecimento", id: "estabelecimento" },
        { displayName: "NºVenda", id: "idNetClinicas" },
        { displayName: "DataCadastro", id: "dataCadastro" },
        { displayName: "Vendedor", id: "usuarioNome" },
        { displayName: "Cliente", id: "clienteNome" },
        { displayName: "Valor", id: "totalVenda" },
        { displayName: "Status", id: "statusVendaDesc" }
    ];

    // *******************************************************************************
    // ************************** CARREGAR ITENS DO CSV ******************************
    // *******************************************************************************
     
    const [dataCSV,setdataCSV] = React.useState([]);  
    const [loadingTable,setloadingTable] = React.useState(false);
    
    const loadDataCsv = (data) =>{
        let dtCsv = [];

        data.map(item =>{
            var obj = {
                estabelecimento: item.estabelecimentoDescricao,
                idNetClinicas: item.idNetClinicas,
                dataCadastro:formateDate(item.dataCadastro),
                usuarioNome: item.usuarioNome,
                clienteNome: item.clienteNome,
                totalVenda: "R$ " + item.totalVenda.toFixed(2).replace('.',','),
                statusVendaDesc: item.statusVendaDesc
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
    } 

    const [showModalContrato, setshowModalContrato] = React.useState(false);
    const [showModalFinalizaContrato, setshowModalFinalizaContrato] = React.useState(false);
    const [showModal, setshowModal] = React.useState(false);
    const [detalheVenda,setdetalheVenda] = React.useState([]);
    const [isLoadingDetalhe,setisLoadingDetalhe] = React.useState(false);
    const handleDetalhe = (row) =>{        
        setisLoadingDetalhe(true);
        const endPoint = "vendas/detalhevendarealizada/" + row.vendaId;
        UseGetApiSimple(endPoint).then(result=>{
            if(result.status !== 200)
            {                                    
                showNotification(result.message,'danger');    
                setisLoadingDetalhe(false);
                return false; 
            }
            setdetalheVenda(result.data); 
            setshowCancelarPagamento(result.data.permiteCancelarVenda);            
            setshowModal(true);
            setisLoadingDetalhe(false);  
            return true;
        });
    }
    const [contratoFranquia, setcontratoFranquia] = React.useState();

    const handleContrato = (row) =>{         
        if (!row)
            return;
        
        setisLoadingDetalhe(true);        
        const endPoint = "contratovendas/" + row.vendaId;
        UseGetApiSimple(endPoint,0).then(result=>{   
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')                    
                setisLoadingDetalhe(false);              
                return false;    
            }  
            setvendaContrato(result.data);      
            setcontratoFranquia(result.data.contratoFranquia);
           
            setisLoadingDetalhe(false);
            setshowModalContrato(true); 
        });
    }

    const handleCancelarPagamento = (row) => {
        setcancelamentoBeakt(true);
    }

    const [alert, setalert] = React.useState();
    const [contratoCancelamento, setcontratoCancelamento] = React.useState(null);
    const handleCancelarContrato = (row) => {
        if (!row)
            return;

        setisLoadingList(true);
        const endPoint = "vendas/VerifyExistEsitefOuSitef/"+ row.vendaId;
        UseGetApiSimple(endPoint).then(result => {
            setisLoadingList(false);
            if (result.status !== 200) {
                showNotification(result.message, 'danger')
                return false;
            }
            if (result.data.possuiSitef == true || result.data.possuiESitef == true) {
                setisLoadingList(false);
                setalert(<SweetAlert
                    warning={true}
                    title={"Atenção"}
                    showConfirm={true}
                    showCancel={true}
                    confirmBtnText={"Confirmar, estou ciente."}
                    cancelBtnText={"Cancelar"}
                    cancelBtnBsStyle={"secondary"}
                    confirmBtnBsStyle={"danger"}
                    onConfirm={() => handleConfirmaCancelarContrato(row, result.data)}
                    onCancel={() => setalert(null)}
                >
                    <p>{t('information_message.confirm_cancel_contract_sitef')}</p>
                    
                </SweetAlert>
                );
            } else {
                setisLoadingList(false);
                setalert(<SweetAlert
                    warning={true}
                    title={"Atenção"}
                    showConfirm={true}
                    showCancel={true}
                    confirmBtnText={"Confirmar"}
                    cancelBtnText={"Cancelar"}
                    cancelBtnBsStyle={"secondary"}
                    confirmBtnBsStyle={"danger"}
                    onConfirm={() => handleConfirmaCancelarContrato(row, result.data)}
                    onCancel={() => setalert(null)}
                >
                    {t('information_message.are_you_sure_you_want_to_cancel_the_contract')}?
                </SweetAlert>
                );
            }
        });

    }
    
    const handleConfirmaCancelarContrato = (contratoCancelamento, result) => {
        let data = {
            usuarioCancelamentoId: session.id,        
            vendaId: contratoCancelamento.vendaId,
            oBS: t('information_message.contract_canceled_by_Headquarters'),
            possuiESITEF: result.possuiESitef,
            possuiSITEF: result.possuiSitef
        }
        
        setalert(null);
        setisLoadingList(true);        
        const endPoint = "vendas/CancelarContrato";
        UsePostApi(endPoint,data).then(result=>{                     
            setisLoadingList(false);
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                return false;    
            }  
                       
            contratoCancelamento.status = 3;
            contratoCancelamento.statusVendaDesc = "Cancelado";
            let listatualizada = list.map(l => (l.vendaId === contratoCancelamento.vendaId ? contratoCancelamento : l));
            setlist(listatualizada);

            showNotification(t('information_message.contract_canceled')+"!", 'success')                        
        });
    }
    const handleReturnCancelamento = () => {
        setisLoadingList(true);
        setcancelamentoBeakt(false);
        setshowModal(false);        
        setTimeout(() => handleClickPesquisa(), 1000);
        
    }

    const handleFinalizaContrato = (row) =>{         
        if (!row)
            return;                                    
        setalert(<SweetAlert
            warning={true}            
            title={"Atenção"}
            showConfirm={true}
            showCancel={true}
            confirmBtnText={"Confirmar"}
            cancelBtnText={"Cancelar"}
            cancelBtnBsStyle={"secondary"}
            confirmBtnBsStyle={"danger"}
            onConfirm={() => handleConfirmaFinalizaContrato(row)}
            onCancel={() => setalert(null)}
        >  
        {t('information_message.are_you_sure_you_want_to_terminated_the_contract')}?
        </SweetAlert>
     );        
    }
    //constantes para abrir o modal de agendamento
    const [ShowModalAgendamentoContrato, setShowModalAgendamentoContrato] = React.useState(false);
    const handleModalAgendamentoContrato = () => {
        setShowModalAgendamentoContrato(true);
    }
    const handleReturnModalAgendamentoContrato = () => {
        showNotification("Agendamento Gravado com sucesso!",'success');  
        
        let data = getValues();

        var dataIniConvertida = convertDate(data.dtini);
        var dataFimConvertida = convertDate(data.dtfim);
        
        creatObjandCallLoadVendas(estabelecimento,dataIniConvertida,dataFimConvertida);
    }
    
    const handleConfirmaFinalizaContrato = (contratoFinalizado) => {
  
        setalert(null);
        setisLoadingList(true);        
        UsePutApi("vendas/FinalizarContrato/", contratoFinalizado.vendaId).then(result => {
            setisLoadingList(false);
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                return false;    
            }  
                       
            contratoFinalizado.status = 5;
            contratoFinalizado.statusVendaDesc = "Finalizado - Concluído";
            showNotification(t('information_message.contract_terminated')+"!", 'success')                        
        });
    }
    
    const handleComprovantesCartao = () => {
        setisLoadingDetalhe(true);
        UseGetApiSimple("vendas/ComprovantesCartao/" + detalheVenda.vendaId, 0).then(result => {
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingDetalhe(false);              
                return false;    
            }  
            if (result.data != "")
            {
                var printWin = window.open('','','left=0,top=0,width=720,height=1000,toolbar=0,scrollbars=0,status=0');
                var html = `<html><head></head><body><div style='white-space:break-spaces'>` + result.data + `</div></body></html>`;
                console.log(html);
                printWin.document.write(html);
                printWin.document.close();
                printWin.focus();
                printWin.print();
                printWin.close();                
            }
            else
                showNotification("Nenhum comprovante disponível para impressão!", 'warning');

            setisLoadingDetalhe(false);
        });        
    }

    const columnsProp = [   
    {
        Header: t('label.establishment'),
        accessor: "estabelecimentoDescricao",
        style: {textAlign: 'center'},
    },     
    {
        Header: "Nº"+t('sale.sale') ,
        accessor: "idNetClinicas",
        style: {textAlign: 'center'},
    },
    {
        Header:t('label.date'),
        accessor:"dataCadastro",
        Cell : (props)=>{
            let custom_date = formateDateandTime(props.value);
            return <span>{custom_date}</span>
        }
    },
    {
        Header: t('sale.user_for_sale'),
        accessor: "usuarioNome"
    },
    {
        Header: t('label.client'),
        accessor: "clienteNome"
    },
    {
        Header: t('label.total'),
        accessor: "totalVenda",
        Cell: (props) => <div> {transformValueFloattoFormated(props.value)} </div>        
    },
    {
        Header: t('label.status'),
        accessor: "statusVendaDesc",
    },
    ]
    const columnsPropClinic = [        
        {
            Header:"Nº"+t('sale.sale'),
            accessor: "idNetClinicas",
            style: {textAlign: 'center'},
        },
        {
            Header:t('label.date'),
            accessor:"dataCadastro",
            Cell : (props)=>{
                const custom_date =  formateDateandTime(props.value);
                return <span>{custom_date}</span>
            }
        },
        {
            Header: t('sale.user_for_sale'),
            accessor: "usuarioNome"
        },
        {
            Header: t('label.total'),
            accessor: "totalVenda",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value)} </div>        
        },
        {
            Header: t('label.status'),
            accessor: "statusVendaDesc",
        },
    ]
    const columnsAcao = [        
    {
        Header: t('label.actions'),
        Cell: row => (
            <div className="actions-right">              
            <Button
                justIcon round simple color="info" 
                onClick={() => handleDetalhe(row.original)}
            > 
            <Tooltip title={t('label.detail')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
            <Search />
            </Tooltip>
            </Button>{" "}              
            {(row.original.possuiContrato 
                && ((row.original.statusVendaDesc === "Finalizado - Ativo" || row.original.statusVendaDesc === "Finalizado - Concluído") ||
                    (session.franquiaId != 0 && row.original.statusVendaDesc === "Cancelado"))) &&
                <Button
                    justIcon round simple color="primary" 
                    onClick={() => handleContrato(row.original)}
                > 
                <Tooltip title={t('label.contract')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Description />
                </Tooltip>
                </Button>
            }
            {
                (session.franquiaId != 0 && 
                (session.tipoPerfil === 0 || 
                 session.tipoPerfil === 4) &&
                (row.original.statusVendaDesc === "Finalizado - Ativo" ||
                 row.original.statusVendaDesc === "Finalizado - Concluído" || 
                 row.original.statusVendaDesc === "Pagamento Estornado")) &&
                <Button
                    justIcon round simple color="danger" 
                    onClick={() => handleCancelarContrato(row.original)}
                > 
                    <Tooltip title={t('button.cancel') +" "+ t('label.contract')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                    <HighlightOffIcon />
                    </Tooltip>
                </Button>
            }

            {(row.original.possuiContrato && BtnFinalizaVenda
                && row.original.statusVendaDesc === "Finalizado - Ativo") &&
                <Button
                    justIcon round simple color="success" 
                    onClick={() => handleFinalizaContrato(row.original)}
                > 
                <Tooltip title={t('button.finish_contract')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                   <PlaylistAddCheckIcon />
                </Tooltip>
                </Button>
            }  
            {(session.franquiaId == 0 && row.original.possuiContrato && row.original.agendamentoPendente
                && row.original.statusVendaDesc === "Finalizado - Ativo") &&
                <Button
                    justIcon round simple color="info" 
                    onClick={() => handleModalAgendamentoContrato()}
                > 
                <Tooltip title={t('agenda.contract_scheduling')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                   <EventNoteIcon />
                </Tooltip>
                </Button>
            }         
        </div>
        ),
        sortable: false,
        filterable: false
    }
    ];
    let columns = "";      
    if(clienteId)
        columns = [...columnsPropClinic,...columnsAcao];
    else    
        columns = [...columnsProp,...columnsAcao]; 
    
    let styledif = {};
    if(clienteId){
        styledif = {
            boxShadow:'none'
        }
    }

return (    

    <div>
        {alert}
        {cancelamentoBeakt && 
            <CancelamentoBeakt detalheVenda={detalheVenda} CallbackGestaoPedidos={handleReturnCancelamento}></CancelamentoBeakt>
        }
        {!cancelamentoBeakt &&
            <GridContainer className="no-print">
                
                <GridItem xs={12}>
                    <Card style={styledif}>
                    <CardHeader color="primary" icon>
                        <CardIcon color="primary">
                            <Assignment />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>{t('sale.sales_management')} </h4>
                    </CardHeader>        
                    <CardBody>
                    {pesquisaContrato &&
                    <SnackbarContent        
                    color={"info"}
                    message={"Não é necessário selecionar estabelecimento e data se pesquisar pelo número da venda"}        
                    />}
                    <GridContainer>
                        {showSelectEstabelecimentos &&
                        <GridItem xs={12} sm={12} md={12}>                
                                <FormControl fullWidth className={classes.formControl}>
                                <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>{t('label.establishment')+" *"} </label>
                                <Select
                                    classNamePrefix="select"
                                    styles={ValidSelect(errors.estabelecimento ? true : false)}
                                    isSearchable={true}
                                    isLoading={isLoadingEstabelecimento}
                                    name="estabelecimento"
                                    placeholder="Selecione..."
                                    options={estabelecimentos}
                                    value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                    getOptionLabel={({ descricao }) => descricao}
                                    getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                    onChange={(value) => handleEstabelecimentoChange(value.estabelecimentoId !== null ? value.estabelecimentoId : "")}
                                    ref={() => register({ name: "estabelecimento" })
                                    }
                                />
                                {errors.estabelecimento &&
                                <FormHelperText>
                                    <span className="obg"> {t('label.select_an_establishment')} </span>
                                </FormHelperText>}
                                </FormControl>                    
                        </GridItem>}
                    </GridContainer>

                    <GridContainer>
                    <GridItem xs={12} sm={6} md={3}>
                            <FormControl fullWidth className={classes.formControl}>                                                               
                                <label className={errors.dtini?"select__label select__label_error":"select__label"}>
                                    {t('label.ini_date')+" *"}  </label>
                                <Datetime                                    
                                    locale={getLocale()}
                                    dateFormat={getStringFormatDate()}
                                    timeFormat={false}                                    
                                    name="dtini"                                      
                                    defaultValue={dtini}
                                    value={dtini}
                                    onChange={date => { setdtini(date) }}
                                    inputProps={{name:"dtini", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                    className={errors.dtini?"error":""}            
                                />       
                                {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                    <span> {t('label.required')} </span>                                                                          
                                </FormHelperText>} 
                                </FormControl>                                 
                        </GridItem>
                        <GridItem xs={12} sm={6} md={3}>
                            <FormControl fullWidth className={classes.formControl}>                                                               
                                <label className={errors.dtfim?"select__label select__label_error":"select__label"}>
                                    {t('label.end_date')+" *"}  </label>
                                <Datetime                                    
                                    locale={getLocale()}
                                    dateFormat={getStringFormatDate()}
                                    timeFormat={false}                                    
                                    name="dtfim"                                      
                                    defaultValue={dtfim}
                                    value={dtfim}
                                    onChange={date => { setdtfim(date) }}
                                    inputProps={{name:"dtfim", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                    className={errors.dtfim?"error":""}            
                                />       
                                {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                    <span> {t('label.required')} </span>                                                                          
                                </FormHelperText>} 
                            </FormControl>                                                                                         
                        </GridItem>
                        {pesquisaContrato &&
                            <GridItem xs={12} sm={3} md={3}> 
                                <FormControl fullWidth className={classes.formControl}>                               
                                <TextField                                        
                                    label={'Nº '+t('sale.sale')}
                                    variant="outlined"
                                    name="vendaContrato"
                                    defaultValue={intialValues.vendaContrato}
                                    InputLabelProps={{shrink: true}}        
                                    inputRef={register({required: false})}
                                    autoComplete="off"
                                />
                                </FormControl>                                 
                            </GridItem>
                        }
                        <GridItem xs={12} sm={6} md={3}>
                        <Button  round color="primary" 
                            onClick={e => { handleClickPesquisa()}}>
                            {t('label.search')} 
                        </Button>
                        </GridItem>

                    </GridContainer>
                    <GridContainer>                                                                        
                                <GridItem xs={12} sm={12} md={12}>
                                        
                                    {dataCSV.length > 0 &&  

                                        <div>
                                            <div style={{float:'right'}}>
                                            <CsvDownloader
                                            filename="Vendas"
                                            columns={columnsCSV}
                                            datas={dataCSV}
                                            separator={";"}>
                                                <Button  round color="default" size="sm" >CSV</Button> 
                                            </CsvDownloader>
                                            </div><div style={{clear:'both'}}></div>
                                        </div>
                                    }
                                </GridItem>            
                        </GridContainer>
                        {notification.show &&
                            <div><br/>
                                <SnackbarContent
                                    message={notification.message}
                                    color={notification.color}
                                    closeNotification={() => setNotification({show:false})}
                                    close
                                />
                            </div>}

                        <ReactTable
                            loading = {isLoadingList}
                            data={list}
                            columns={columns}
                            filterable
                            defaultFilterMethod = {noCaseSensitive}
                            defaultPageSize={10}
                            minRows={5}
                            showPaginationBottom={true}
                            className="-striped -highlight"
                            previousText={t('button.previous')}
                            nextText={t('button.next')}
                            loadingText={t('label.loading')+"..."}
                            noDataText={t('information_message.no_records_found')+"!"}
                            pageText={t('label.page')}
                            ofText={t('label.of')}
                            rowsText={t('label.rows')}
                        />
                    </CardBody>
                    </Card>
                </GridItem>
                
                {isLoadingDetalhe && 
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div> 
                }

                <Dialog
                classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
                open={showModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setshowModal(false)}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description"
                >
                    <DialogTitle
                        id="classic-modal-slide-title"
                        disableTypography
                        className={classes.modalHeader}
                        style={{background:'#5c4477'}}
                    >
                        <Button
                            justIcon
                            className={classes.modalCloseButton}
                            key="close"
                            aria-label="Close"
                            color="transparent"
                            onClick={() => setshowModal(false)}
                        >
                            <Close className={classes.modalClose} />
                        </Button>
                            <h4 className={classes.modalTitle} style={{color:'white'}}>{t('sale.detail_of_Sale')} </h4>
                        </DialogTitle>
                        <DialogContent id="classic-modal-slide-description"
                            className={classes.modalBody} 
                        >                           
                            <div>
                            {notification.show &&
                                <div><br/>
                                <SnackbarContent
                                    message={notification.message}
                                    color={notification.color}
                                    closeNotification={() => setNotification({show:false})}
                                    close
                                /></div>}
                                <h6 style={{textAlign:'right'}}>{t('sale.Sale_completed')}: {formateDateandTime(detalheVenda.dataCadastro)}</h6>
                                {detalheVenda.usuarioCancelamento && <div className="no-print">
                                    <SnackbarContent
                                        color={"warning"}
                                        message={"Contrato cancelado no dia " + formateDateandTime(detalheVenda.dataCancelamento) + " pelo usuário " + detalheVenda.usuarioCancelamento + ". (Possui transação ESitef: " + (detalheVenda.possuiESITEF ? "Sim" : "Não") + " / Possui transação Sitef: " + (detalheVenda.possuiSITEF ? "Sim" : "Não") + ")"}
                                    />
                                </div>}
                                <h5>
                                    <b>{t('sale.sale')} </b> {detalheVenda.idNetClinicas}
                                    <b style={{marginLeft:'20px'}}>{t('label.client')}:</b> {detalheVenda.clienteNome}
                                    <b style={{marginLeft:'20px'}}>{t('sale.sale_status')}:</b> {detalheVenda.statusVendaDesc}
                                </h5>
                                <h5>
                                    <b>{t('sale.user_for_sale')}:</b> {detalheVenda.usuarioVenda}
                                    <b style={{marginLeft:'20px'}}>{t('label.user_registration')}:</b> {detalheVenda.usuarioNome}
                                </h5>
                                <br/>          
                                <h4>{t('sale.sale_items')} </h4>
                                <table className="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>{t('label.description')}</th>
                                        <th>{t('label.quantity')}</th>
                                        <th>{"R$ "+ t('label.unitary') }</th>
                                        <th>{"R$ "+ t('label.discount')}</th>
                                        <th>{"R$ "+ t('label.total')}</th>
                                    </tr>
                                    </thead>
                                    <tbody>  
                                    {detalheVenda.vendaGestaoItens && detalheVenda.vendaGestaoItens.map(item => ( 
                                        <tr key={item.id}>
                                            <td>{item.descricao}</td>
                                            <td>{item.qtd}</td>
                                            <td>{transformValueFloattoFormated(item.valorUnitario)}</td>
                                            <td>{transformValueFloattoFormated(item.valorDesconto)}</td>
                                            <td>{transformValueFloattoFormated(item.valorTotalComDesconto)}</td>
                                        </tr> ))}                               
                                    </tbody>
                                    </table>
                                        
                                    <h4 style={{marginTop:'25px'}}>{t('sale.payments')}</h4>
                                    <table className="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>{t('label.description')} </th>
                                        <th>{t('label.detail')} </th>
                                        <th>{"R$ "+ t('label.value')} </th>
                                    </tr>
                                    </thead>
                                    <tbody>  
                                    {detalheVenda.vendaGestaoPagamentos && detalheVenda.vendaGestaoPagamentos.map(item => ( 
                                        <tr key={item.id}>
                                            <td>{item.descricao}</td>
                                            <td>{item.detalhe}</td>
                                            <td>{transformValueFloattoFormated(item.valor)}</td>
                                        </tr> ))
                                    }
                                    </tbody>
                                    </table>
                                    <center>
                                    {showCancelarPagamento &&                                 
                                            <Button color="primary" onClick={() => handleCancelarPagamento()}>
                                                {t('sale.cancel_payment')}
                                            </Button>                                    
                                        
                                    }                
                                    {(detalheVenda.vendaGestaoPagamentos != null &&
                                        detalheVenda.vendaGestaoPagamentos.filter(f => f.tipo == 1).length > 0) &&                                
                                            <Button color="info" onClick={() => handleComprovantesCartao()}>
                                                {t('sale.receipt_card')}
                                            </Button>                                
                                    }   
                                    </center>         
                                    <br/>     
                                </div>          
                        </DialogContent>
                    </Dialog>
                    
                    <Dialog
                        classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
                        open={showModalContrato}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => setshowModalContrato(false)}
                        aria-labelledby="classic-modal-slide-title"
                        aria-describedby="classic-modal-slide-description"
                        >
                            <DialogTitle
                                id="classic-modal-slide-title"
                                disableTypography
                                className={classes.modalHeader}
                                style={{background:'#5c4477'}}
                            >
                                <Button
                                    justIcon
                                    className={classes.modalCloseButton}
                                    key="close"
                                    aria-label="Close"
                                    color="transparent"
                                    onClick={() => setshowModalContrato(false)}
                                >
                                    <Close className={classes.modalClose} />
                                </Button>
                                    <h4 className={classes.modalTitle} style={{color:'white'}}>{t('sale.contract_sale')} </h4>
                                </DialogTitle>
                                <DialogContent id="classic-modal-slide-description"
                                    className={classes.modalBody} style={{background:'#f0f0f0'}}
                                >                 
                                <br/>
                                {contratoFranquia == 'Emagrecentro' && <ContratoVenda  venda={vendaContrato}></ContratoVenda >}
                                {contratoFranquia == 'CamaCam' && <ContratoVendaCamaCam  venda={vendaContrato}></ContratoVendaCamaCam >}
                                {contratoFranquia == 'DM2' && <ContratoVendaDM2 venda={vendaContrato}></ContratoVendaDM2 >}

                        </DialogContent>
                    </Dialog>
                    <Dialog
                        classes={{
                            root: classes.center + " " + classes.modalRoot,
                            paper: classes.modal + ' ' + classes.modalLarge
                        }}
                        fullWidth
                        maxWidth="lg"
                        open={ShowModalAgendamentoContrato}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => setShowModalAgendamentoContrato(false)}
                        aria-labelledby="classic-modal-slide-title"
                        aria-describedby="classic-modal-slide-description"
                    >
                        <AgendamentoContrato callback={handleReturnModalAgendamentoContrato} closemodal={() => setShowModalAgendamentoContrato(false)} showmodal={ShowModalAgendamentoContrato} />
                
                    </Dialog>
            </GridContainer>    
        }
    </div>
);
}
  
